import { Component } from "@angular/core";
import { SharedService } from "../shared/service";

@Component({
  templateUrl: './recover.header.html'
})
export class RecoverHeader {

  constructor(public shared: SharedService) { }

}
